import { useTranslation } from 'react-i18next';

export default function CompareSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-foreground-950 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mb-5 inline-block h-px w-12 bg-primary-500"></span>
          <h2 className="font-heading text-3xl leading-tight text-background-50 md:text-4xl lg:text-5xl">
            {t('s2.title')}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2">
          <div className="reveal reveal-delay-1 overflow-hidden rounded-lg border border-foreground-700/60 bg-foreground-900/60">
            <div className="relative h-64 w-full md:h-72">
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20car%20parked%20on%20an%20open%20driveway%20exposed%20to%20the%20elements%20in%20daylight%2C%20plain%20open%20outdoor%20parking%20area%20beside%20a%20villa%2C%20neutral%20flat%20lighting%2C%20minimalist%20composition%2C%20high%20detail%2C%20professional%20editorial%20automotive%20photography&width=1200&height=800&seq=vg-open-01&orientation=landscape"
                alt={t('s2.openTitle')}
                title={t('s2.openTitle')}
                className="h-full w-full object-cover object-top opacity-70"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900 to-transparent"></div>
            </div>
            <div className="px-6 pb-7 pt-5">
              <h3 className="font-heading text-xl text-background-100/80 md:text-2xl">
                {t('s2.openTitle')}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-100/50 md:text-base">
                {t('s2.openDesc')}
              </p>
            </div>
          </div>

          <div className="reveal reveal-delay-2 overflow-hidden rounded-lg border border-primary-500/40 bg-gradient-to-b from-foreground-900 to-foreground-950">
            <div className="relative h-64 w-full md:h-72">
              <img
                src="https://storage.helloreaddy.io/project_files/23cbf37b-3b60-45d6-b458-2fbb3e9ec10a/26556652-14bd-4784-93b0-8d2e327d2dd4_compressed_2.webp"
                alt={t('s2.garageTitle')}
                title={t('s2.garageTitle')}
                className="h-full w-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 to-transparent"></div>
              <span className="absolute top-4 start-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-foreground-950">
                {t('brand.name')}
              </span>
            </div>
            <div className="px-6 pb-7 pt-5">
              <h3 className="font-heading text-xl text-primary-400 md:text-2xl">
                {t('s2.garageTitle')}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-100/80 md:text-base">
                {t('s2.garageDesc')}
              </p>
            </div>
          </div>
        </div>

        <div className="reveal reveal-delay-3 mt-12 text-center">
          <a
            href="#iletisim"
            className="inline-block whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
          >
            {t('s2.cta')}
          </a>
        </div>
      </div>
    </section>
  );
}